export default __webpack_public_path__ + "static/media/image_demo_wellness_service.ef9757b4.svg";